var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "select_client_company",
          attrs: {
            id: "select-client-company",
            title: "顧客選択",
            size: "xl",
            "header-bg-variant": "dark",
            "header-text-variant": "light",
            "body-bg-variant": "light",
            "hide-footer": "",
            centered: "",
          },
          on: { hidden: _vm.onModalHide },
        },
        [
          _c("div", [
            _c(
              "div",
              { staticStyle: { width: "1200px" } },
              [
                _c("b-table-filter-pager", {
                  attrs: {
                    busy: _vm.busy,
                    maxHeight: _vm.maxHeight,
                    filter_list: _vm.filter_list,
                    filter_val: _vm.filter_val,
                    filter_val_ex: _vm.filter_val_ex,
                    data_list_field: _vm.data_list_field,
                    data_list: _vm.data_list,
                    edit_disabled: _vm.pms_master_client_company < 2,
                    data_count: _vm.data_count,
                    currentPage: _vm.current_page,
                    filter_enable: true,
                    nav_flg: true,
                  },
                  on: {
                    on_sort: _vm.onSort,
                    on_page_change: _vm.onPageChange,
                    on_edit: _vm.onDetail,
                    on_add: _vm.modalShow,
                    on_select: _vm.onSelect,
                    on_filter_ex: _vm.onFilterEx,
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-client_company2",
            title: "顧客 > 追加",
            "header-bg-variant": "dark",
            "header-text-variant": "light",
            "body-bg-variant": "light",
            "hide-footer": "",
            centered: "",
          },
        },
        [
          _c("div", { staticClass: "modal_div" }, [
            _c(
              "div",
              { staticClass: "form-inline" },
              [
                _c("label", [_vm._v("顧客コード")]),
                _vm._v(" "),
                _c("b-input", {
                  attrs: { type: "text" },
                  model: {
                    value: _vm.client_company.company_code,
                    callback: function ($$v) {
                      _vm.$set(_vm.client_company, "company_code", $$v)
                    },
                    expression: "client_company.company_code",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-inline" },
              [
                _c("label", [_vm._v("顧客名")]),
                _vm._v(" "),
                _c("b-input", {
                  staticStyle: { width: "300px" },
                  attrs: { type: "text" },
                  model: {
                    value: _vm.client_company.company_name,
                    callback: function ($$v) {
                      _vm.$set(_vm.client_company, "company_name", $$v)
                    },
                    expression: "client_company.company_name",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-inline" },
              [
                _c("label", [_vm._v("担当者")]),
                _vm._v(" "),
                _c(
                  "b-form-select",
                  {
                    staticStyle: { width: "200px" },
                    model: {
                      value: _vm.client_company.user_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.client_company, "user_id", $$v)
                      },
                      expression: "client_company.user_id",
                    },
                  },
                  _vm._l(_vm.sel_user_list, function (option) {
                    return _c(
                      "option",
                      { key: option.id, domProps: { value: option.value } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(option.text) +
                            "\n          "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-footer" },
            [
              _c(
                "b-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$bvModal.hide("modal-client_company2")
                    },
                  },
                },
                [
                  _c("b-icon", { attrs: { icon: "x" } }),
                  _vm._v("取消\n      "),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { variant: "primary" },
                  on: { click: _vm.updateClientCompany },
                },
                [
                  _c("b-icon", { attrs: { icon: "save" } }),
                  _vm._v(" 保存\n      "),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("MasterClientCompanyDetail", {
        ref: "child_master_client_company_detail2",
        attrs: {
          modal_id: "master_client_company-master_client_company_detail2",
          top_title: "顧客 > 編集",
        },
        on: { close_modal: _vm.closeDetailModal },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }